import { useLayoutEffect, useRef, useState } from "react";

// Measure the space actually available to the carousel, including resizing
// in browser device emulation and narrow parent containers.
export default function useCarouselLayout(maxSlides, tabletWidth = 1000) {
  const containerRef = useRef(null);
  const countForWidth = (width) => width < 640 ? 1 : width < tabletWidth ? 2 : maxSlides === 4 && width < 1200 ? 3 : maxSlides;
  const [slidesToShow, setSlidesToShow] = useState(() => countForWidth(window.innerWidth));

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const update = () => {
      const width = Math.min(container.clientWidth, window.innerWidth);
      setSlidesToShow(width < 640 ? 1 : width < tabletWidth ? 2 : maxSlides === 4 && width < 1200 ? 3 : maxSlides);
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(container);
    window.addEventListener("resize", update);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", update);
    };
  }, [maxSlides, tabletWidth]);

  return { containerRef, slidesToShow };
}
